/*
 * <rider-reviews>: cards rise in once when the grid enters view; "Show more reviews" reveals the rest
 * (on phones that includes the cards held back to keep the section short) with the same entrance.
 * Reduced motion: no entrance, content shows immediately.
 */
if (!customElements.get('rider-reviews')) {
  class RiderReviews extends HTMLElement {
    connectedCallback() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!reduceMotion && 'IntersectionObserver' in window) {
        this.classList.add('rr-armed');
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          requestAnimationFrame(() => {
            this.querySelectorAll('.review:not([hidden])').forEach((card) => card.classList.add('is-in'));
          });
        }, { threshold: 0.12 });
        this.observer.observe(this.querySelector('.rider-reviews__grid'));
      }

      const toggle = this.querySelector('[data-review-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', () => {
        const more = Array.from(this.querySelectorAll('[data-review-more], [data-review-more-mobile]'));
        more.forEach((card) => {
          card.classList.remove('is-in');
          card.hidden = false;
        });
        this.classList.add('is-expanded');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.closest('.rider-reviews__more').hidden = true;
        // Two frames so the newly shown cards paint in their start state before rising in
        requestAnimationFrame(() => requestAnimationFrame(() => more.forEach((card) => card.classList.add('is-in'))));
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  customElements.define('rider-reviews', RiderReviews);
}
